export const DISPOSABLE_EMAILS_DOMAINS = [
  'nightorb.com',
  'studentasvalencia.org',
  'k12.pa.us',
  'tp.edu.tw',
  'pcr.ac.id',
  'etu-its.fr',
  'glenrocknj.org',
  'eclipso.de',
  'tcwlm.com',
  'radiant-flow.org',
  'quiet-branch.com',
  'emailabox.pro',
  'qodiq.com',
  'nolanzip.com',
  'isco.eu.org',
  'tempmail',
  'jadsys.com',
  'salesianos-lacuesta.net',
  'tulria.com',
  'datingel.com',
  'iminko.com',
  'rustetic.com',
  'teleg.eu',
  'snavep.com',
  'jxpomup.com',
  'tidissajiiu.com',
  'eoilup.com',
  'pokeline.com',
  'ndoverneuil.net',
  'bawsny.com',
  'luxyss.com',
  'eskibel.com',
  '2ndsyndrome.com',
  'pinescharter.net',
  'belajar.id',
  'phyones.com',
  'freesourcecodes.com',
  '.ac.in',
  'ssd412.org',
  'educbe.ca',
  'evusd.com',
  'somoj.com',
  'pullnks.com',
  'tumroc.net',
  'kelenson.com',
  'cantozil.com',
  'mozmail.com',
  'rotherglen.com',
  'inohm.com',
  'oasisdemaadi.com',
  'kindomd.com',
  'jonespal.com',
  'bflcafe.com',
  'tignee.com',
  '.ac.id',
  'mytusd.org',
  'raksoholdings.com',
  // 'passinbox.com',
  'gufum.com',
  'sablecc.com',
  'gmailod.com',
  'qdeliverssx.com',
  'opposir.com',
  'operades.com',
  'kakao.com',
  'zvvzuv.com',
  'inikale.com',
  'poplk.com',
  'knmcadibav.com',
  'bltiwd.com',
  'qejjyl.com',
  '1secmail.ru',
  'sookmyung.ac.kr',
  'elpilarmaristas.net',
  'traisach.com',
  'lineacr.com',
  'hthlm.com',
  'dygovil.com',
  'goeschman.com',
  'recorderxfm.com',
  'slps.prg',
  'azuretechtalk.net',
  'lsmaravillas.com',
  'hsps.us',
  'emailfoxi.pro',
  'bcampbelleo.com',
  '.party',
  '.date',
  'merotx.com',
  'kazvi.com',
  'puxah.org',
  'nozamas.com',
  'kimasoft.com',
  'gitated.com',
  'tec.mx',
  'cashbn.com',
  'ytnhy.com',
  'smp.belajar.id',
  'emailvb.pro',
  'cpaurl.com',
  'muatoc.com',
  'newslabturkey.org',
  'konican.com',
  'abv.bg',
  'moonwall.org',
  'boonecountyboe.org',
  'ess-aarhus.dk',
  'ess-aarhus.dk',
  'qcsd.org',
  'lcsd56g.com',
  'iespinorueda.com',
  'goe.go.kr',
  'belgianairways.com',
  'grupojyrcr.com',
  'parkwayschools.net',
  'wyoxafp.com',
  'frsu38.org',
  'ajou.ac.kr',
  'aucklanduni.ac.nz',
  'moed.bm',
  'dlsinc.com',
  'kyonggi.ac.kr',
  'qodiq.com',
  '@daum.net',
  'walshun.com',
  'exoular.com',
  'instaddr.ch',
  'xoroda.com',
  'educar.jccm.es',
  'nbmbb.com',
  'deped.gov.ph',
  'velvet-mag.lat',
  'suotxt.com',
  'unobitex.com',
  'gianes.com',
  'anypng.com',
  'laoraclej.com',
  'boxmail.lol',
  'flashpost.net',
  'bmobilerk.com',
  'moneychair.org',
  '.cat',
  'kisoq.com',
  'smykwb.com',
  'cironex.com',
  'edectus.com',
  '.xyz',
  '.space',
  '.lol',
  'snapmail.cc',
  'brinkc.com',
  'albarulo.com',
  'doads.org',
  'shareaccountvn.com',
  'mailvn.top',
  'wellorg.com',
  'vidney.com',
  'heweek.com',
  'pelagius.net',
  'nowni.com',
  'chrfueeul.com',
  'sigmazon.com',
  'mailnuo.com',
  'dcobe.com',
  'ofionk.com',
  'marchub.com',
  'dccco.coop',
  'rfcdrive.com',
  'cetnob.com',
  'xycab.com',
  'asaud.com',
  'kellerisd.com',
  'nastyx.com',
  'degcos.com',
  'tohup.com',
  'psnator.com',
  'polatrix.com',
  'mailvoxa.com',
  'moonversion.com',
  'rackabzar.com',
  'wxter.com',
  'gonetor.com',
  'zlorkun.com',
  'reebsd.com',
  'modotso.com',
  'superrito.com',
  'floodouts.com',
  'icevex.com',
  'cnavaro.com',
  'telegmail.com',
  'hellomailo.net',
  'greendike.com',
  'gudri.com',
  'disipulo.com',
  'wywnxa.com',
  'stempmail.com',
  'bacaki.com',
  'yt-google.com',
  'atebin.com',
  'carspure.com',
  'bsidesmn.com',
  'pelagius.net',
  'clip.lat',
  'furnato.com',
  'apn7.com',
  'cartep.com',
  'webonoid.com',
  'iucake.com',
  'cyclelove.cc',
  'seetarycr.com',
  'citmo.net',
  'agaseo.com',
  'navalcadets.com',
  'mxscout.com',
  'cutxsew.com',
  'buzblox.com',
  'moongit.com',
  'valanides.com',
  'yousmail.com',
  'guerrillamail',
  'grr.la',
  'pokemail.net',
  '2925.com',
  'tormails.com',
  'spam4.me',
  'temporary-mail.co',
  'themesw.com',
  'dispostable.com',
  'tingn.com',
  'inboxkitten.com',
  'pixerz.com',
  'vingood.com',
  'tmmbt.net',
  'letpays.com',
  'emailforyou.info',
  'ayoaly',
  'fkcod.com',
  'fullypaidpo',
  'kmfpo.nvsu',
  'emailkom.live',
  'usharer.com',
  'secretmail.net',
  'crankymonkey.info',
  'wireconnected.com',
  'popcornfly.com',
  'hi2.in',
  'unicsite.com',
  'techcz.com',
  'foundtoo.com',
  'v3dev.com',
  'ekcsoft.com',
  'eurokool.com',
  'ezgiant.com',
  'necktai.com',
  'jobsfeel.com',
  'etondy.com',
  'orgria.com',
  'othao.com',
  'mkurg.com',
  'newnime.com',
  'rdluxe.com',
  'donymails.com',
  'explodemail.com',
  'cmeinbox.com',
  'decabg.eu',
  'moontrack.net',
  'omeie.com',
  'guerrillamail.de',
  'gaymail.buzz',
  'nezid.com',
  'tmmbt.com',
  'razuz.com',
  'tmmcv.com',
  'octovie.com',
  'triots.com',
  'tmpnator.live',
  'mailinator.com',
  'subdito.com',
  'fexpost.com',
  'yopmail.com',
  'karenkey.com',
  'drewzen.com',
  'instasmail.com',
  'prolug.com',
  'dewareff.com',
  'dentaltz.com',
  'brand-app.biz',
  'tmmwj.com',
  'fireboxmail.lol',
  'tmmcv.net',
  'oxomail.org',
  'lyricspad.net',
  'haikido.com',
  'pro5g.com',
  'trash-mail.com',
  'trash-mail.com',
  'jrs77.com',
  'lyft.live',
  'mailto.plus',
  'doublemail.de',
  'chnlog.com',
  'kaftee.com',
  'sharklasers.com',
  'khaxan.com',
  'joesdk.com',
  'bundlesjd.com',
  'fanneat.com',
  'nazyno.com',
  'funnymail.de',
  'dropsin.net',
  'voopmail.com',
  'funnymail.de',
  'amailhost.xyz',
  'tmail9.com',
  'tmail6.com',
  'digismail.com',
  'woopros.com',
  'randomail.io',
  'privacylock.net',
  'tempr.email',
  'xcoxc.com',
  'useburnermail.com',
  'mycreativeinbox.com',
  'instantbox.live',
  'allwebemails.com',
  'mailmagnet.co',
  'emalupe.com',
  'obee.info',
  'rendtoo.com',
  // 21 accounts in one hour behind Cloudflare Email Routing (2026-09-22)
  'myerly.com',
  // Lookalike of Outlook (not Microsoft: Cloudflare Email Routing, registered
  // 2025-05 via gname.com). 11 signups with random 8-char local parts; the
  // 2026-09-25/26 accounts ran bots named "Claude" as a free Gemini API.
  'outlook.tw',
  // Public Brazilian temp-mail site ("email temporário público e sem cadastro")
  'tuamaeaquelaursa.com',
];
